export default {
    title: "Neuigkeiten",
    description: "Hier kannst du Neuigkeiten für deine Organisation / deinen Verband bearbeiten.",
    content: "Inhalt",
    saveContent: "Speichern",
}